// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"deleteButton_deleteButton___urNX"};